import React, { useState, useEffect } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import SupplierService from '../services/SupplierService';

const SupplierAutoComplete = ({ value, onChange, placeholder = "Tedarikçi Ara...", className = "" }) => {
    const [suggestions, setSuggestions] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState(null);

    useEffect(() => {
        if (value && typeof value === 'number') {
            SupplierService.getSupplierById(value).then(data => {
                setSelectedSupplier(data);
            });
        } else if (!value) {
            setSelectedSupplier(null);
        }
    }, [value]);

    const search = async (event) => {
        try {
            // SupplierService does not have an explicit autocomplete yet,
            // but we can use getAllSuppliers and filter client side for now
            // OR use the combo endpoint if it supports search.
            // Assuming we might need a proper search endpoint later,
            // but for now let's try to find if there is one.
            const all = await SupplierService.getAllSuppliers();
            const filtered = all.filter(s => s.name.toLowerCase().includes(event.query.toLowerCase()));
            setSuggestions(filtered);
        } catch (error) {
            console.error("Tedarikçi arama hatası:", error);
        }
    };

    const onSelect = (e) => {
        setSelectedSupplier(e.value);
        onChange(e.value.id);
    };

    const itemTemplate = (item) => {
        return (
            <div className="flex flex-column">
                <span className="font-bold">{item.name}</span>
                <small className="text-gray-500">{item.phoneNumber}</small>
            </div>
        );
    };

    return (
        <AutoComplete
            value={selectedSupplier}
            suggestions={suggestions}
            completeMethod={search}
            field="name"
            placeholder={placeholder}
            itemTemplate={itemTemplate}
            onChange={(e) => {
                if (e.value === '') {
                    setSelectedSupplier(null);
                    onChange(null);
                } else {
                    setSelectedSupplier(e.value);
                }
            }}
            onSelect={onSelect}
            className={className}
            dropdown
        />
    );
};

export default SupplierAutoComplete;
